import { Component, DestroyRef, inject, signal } from '@angular/core';
import { form, FormField, required } from '@angular/forms/signals';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { AssetService } from '../../../../services/asset';
import { ModelSelect } from '../../../../utilities/components/model-select/model-select';
import { NotificationService } from '../../../../utilities/services/notification.service';
import { SpinnerLoaderDirective } from '../../../../utilities/directives/spinner-loader.directive';
import { DeviceModelItem } from '../../../../models/asset';

@Component({
  selector: 'fs-device-pair-modal',
  imports: [ModelSelect, FormField, SpinnerLoaderDirective],
  templateUrl: './device-pair-modal.html',
  styleUrl: './device-pair-modal.scss',
})
export class DevicePairModal {
  private readonly destroyRef = inject(DestroyRef);
  protected readonly activeModal = inject(NgbActiveModal);
  private readonly assetService = inject(AssetService);
  private readonly notificationService = inject(NotificationService);

  private readonly pairModel = signal({
    assetModel: null as DeviceModelItem | null,
    description: ''
  });
  protected pairForm = form(this.pairModel, (schemaPath) => {
    required(schemaPath.assetModel, { message: 'Inserire il nome del modello' });
    required(schemaPath.description, { message: 'Selezionare il produttore' });
  });

  protected pairSubscription!: Subscription;

  protected saveModel() {
    this.pairForm().markAsTouched();
    if (this.pairForm().invalid()) return;

    const data = {
      description: this.pairForm().value().description,
      assetModel: { id: this.pairForm().value().assetModel?.id }
    };
    this.pairSubscription = this.assetService.createDeviceFlow(data).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.activeModal.close('refresh');
      this.notificationService.showToast('L\'assets è stato correttamente associato', { type: 'success' } );
    });
  }
}
